// extracted by mini-css-extract-plugin
export default {"box":"orderListPage_box__mTNuf"};